import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatError, MatFormField, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { Store } from '@ngrx/store';
import { AuthActions, AuthSelectors } from '@ngrx-store';
import { Observable } from 'rxjs';

import { passwordValidationPattern } from '../../../constants';
import { formUtils } from '../../../helpers';
import { PasswordRequirementsComponent } from '../../password-requirements/password-requirements.component';

@Component({
  imports: [
    MatError,
    MatSuffix,
    ReactiveFormsModule,
    MatInput,
    MatFormField,
    MatDialogModule,
    AsyncPipe,
    MatProgressSpinner,
    PasswordRequirementsComponent,
  ],
  selector: 'app-change-password-dialog',
  templateUrl: './change-password-dialog.component.html',
})
export class ChangePasswordDialogComponent {
  isLoading$!: Observable<boolean | undefined>;
  form: FormGroup;
  hideInput = {
    confirmPassword: true,
    password: true,
  };

  private fb = inject(FormBuilder);
  private store = inject(Store);

  constructor() {
    this.isLoading$ = this.store.select(AuthSelectors.isLoading);
    this.form = this.fb.group(
      {
        confirmPassword: ['', [Validators.required, Validators.pattern(passwordValidationPattern)]],
        password: ['', [Validators.required, Validators.pattern(passwordValidationPattern)]],
      },
      {
        validator: formUtils.confirmedValidator('password', 'confirmPassword'),
      },
    );
  }

  saveChanges() {
    if (this.form.valid) {
      this.store.dispatch(AuthActions.authChangeUserPassword({ data: this.form.value }));
    }
  }
}

export function openChangePasswordDialog(dialog: MatDialog) {
  const config = new MatDialogConfig();

  config.disableClose = true;
  config.backdropClass = 'backdrop-modal-panel';
  const dialogRef = dialog.open(ChangePasswordDialogComponent, config);

  return dialogRef.afterClosed();
}
